import { Fancybox } from '@fancyapps/ui'
import fancyboxOptions from '../../components/modal/fancybox/fancybox'

const forms = document.querySelectorAll('form')
if (forms.length) {
	forms.forEach(form => {
		form.addEventListener('submit', event => {
			if (form.querySelectorAll('.field__item_error').length === 0) {
				event.preventDefault()

				const name = form.querySelector('[name="name"]').value
				const message = form.querySelector('[name="message"]')
				const phone = form.querySelector('[name="phone"]')
				const email = form.querySelector('[name="email"]')

				let data = `action=submitAjaxForm&name=${name}`
				if (phone) {
					data += `&phone=${phone.value}`
				}
				if (email) {
					data += `&email=${email.value}`
				}
				if (message) {
					data += `&message=${message.value}`
				}
				const request = new XMLHttpRequest()
				request.open('post', WPJS.themeAjax, true)
				request.setRequestHeader("Content-Type", "application/x-www-form-urlencoded; charset=UTF-8")
				request.onload = () => {
					Fancybox.close()
					setTimeout(() => {
						Fancybox.show([
							{ src: '#modal-complete' }
						], fancyboxOptions)
					}, 300)
					form.reset()
				}
				request.send(data)
			}
		})
	})
}
